export const FORM_LANGUAGE_OPTIONS = [
    { value: 'sv', key: 'swedish' },
    { value: 'en', key: 'english' },
    { value: 'fi', key: 'finnish' },
    { value: 'de', key: 'german' },
    { value: 'no', key: 'norwegian' },
    { value: 'da', key: 'danish' },
];
